import { useCallback } from 'react'
import { ModalSize } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { useModal } from 'app/components'
import { DispositivoGestaoView } from '../../core/_models'
import { DispositivoModal } from './DispositivoModal'

/** Abre o `DispositivoModal` em edição; `buscar` entrega o cadastro que o formulário edita. */
export const useEditarDispositivo = () => {
  const { showModal } = useModal()
  const { t } = useT()
  return useCallback(
    (nome: string, buscar: () => Promise<DispositivoGestaoView>) =>
      showModal({
        title: t('pagina.dispositivos.modal.titulo_editar'),
        description: nome,
        content: <DispositivoModal />,
        size: ModalSize.ExtraLarge,
        fetchers: { dispositivo: buscar },
      }),
    [showModal, t]
  )
}
